"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var UserGroupIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.773 6.616a4.5 4.5 0 00-5.757 6.733c-1.136.28-2.03.728-2.688 1.325A11.011 11.011 0 011 12C1 5.928 5.928 1 12 1s11 4.928 11 11c0 1.167-.182 2.293-.52 3.348-.751-1.046-1.933-1.825-3.57-2.302a5.587 5.587 0 10-9.138-6.43z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.597 15.012c-.86.992-1.283 2.256-1.283 3.757v1.964a11.055 11.055 0 01-3.162-3.829c.443-.972 1.623-1.78 4.445-1.892zm2.36-6.543a5.603 5.603 0 00.402 3.703 2.5 2.5 0 11-.4-3.703z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.405 21.996v-3.14c0-1.954 1.078-4.043 6.991-4.043 5.014 0 6.529 1.469 6.893 3.08A10.995 10.995 0 0112 23c-1.64 0-3.197-.36-4.595-1.004zm6.991-8.747a3.496 3.496 0 110-6.991 3.496 3.496 0 010 6.991z"
  })));
});
UserGroupIcon.category = 'Profile';
var _default = UserGroupIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/UserGroupIcon.js
// module id = 1171
// module chunks = 0